var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 68,
    viewBox: "0 0 192 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.515625,
    y: 32.6885,
    width: 8.70007,
    height: 34.7422,
    rx: 4.35004,
    fill: "#A0EAA3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2427,
    y: 21.8311,
    width: 8.70007,
    height: 45.5992,
    rx: 4.35004,
    fill: "#A0EAA3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45.9697,
    y: 32.6885,
    width: 8.70007,
    height: 34.7422,
    rx: 4.35004,
    fill: "#A0EAA3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6973,
    y: 10.9746,
    width: 8.70007,
    height: 56.4561,
    rx: 4.35004,
    fill: "#A0EAA3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91.4243,
    y: 21.8311,
    width: 8.70007,
    height: 45.5992,
    rx: 4.35004,
    fill: "#A0EAA3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 114.151,
    y: 10.9746,
    width: 8.70007,
    height: 56.4561,
    rx: 4.35004,
    fill: "#A0EAA3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 136.878,
    y: 0.117188,
    width: 8.70007,
    height: 67.3131,
    rx: 4.35004,
    fill: "#2D2F31"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 159.605,
    y: 10.9746,
    width: 8.70007,
    height: 56.4561,
    rx: 4.35004,
    fill: "#A0EAA3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 182.333,
    y: 10.9746,
    width: 8.70007,
    height: 56.4561,
    rx: 4.35004,
    fill: "#A0EAA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileview);
export default __webpack_public_path__ + "static/media/profileview.d62ed73b8b05be725e65186bf28b9c07.svg";
export { ForwardRef as ReactComponent };